module.exports = __webpack_public_path__ + "static/media/white-logo.b12cac16.svg";